import { KeyboardShortcutName } from '../../../cross-team-shared/misc-services/keyboard-shortcut.service';
import { outputShortcuts2d } from '../annotation-shared/output-shortcuts-2d';

export const imageAnnotationShortcuts: KeyboardShortcutName[] = [
  ...outputShortcuts2d,
  'selectFillTool',
  'selectPaintbrushTool',
  'selectSuperpixelTool',
];
